const Hindi = {
    "English(en)": "Hindi(hi)",
    "Announcements": "घोषणाएं",
    "Featured Posts": "चुनिंदा पोस्ट्स",
    "Action Required": "कार्रवाई आवश्यक है",
    "more liked this": "इसे और अधिक पसंद किया गया",
    "Comments": "टिप्पणियाँ",
    "Awards": "पुरस्कार",
    "Upcoming Birthdays": "आगामी जनमदिन",
    "Upcoming Work-Anniversaries": "आगामी कार्य-वर्षगाँठ",
    "Popular Posts": "लोकप्रिय लेख",
    "Upcoming Wedding Anniversaries": "आगामी विवाह वर्षगाँठ",
    "Reference site about lorem ipsum, giving information": "लोरेम इप्सम के बारे में संदर्भ साइट, जानकारी दे रही है..",
    "Follow Up Suggestions": "सुझावों का पालन करें",
    "Feed": "खिलाना",
    "Post": "डाक",
    "My Feeds": "मेरी फ़ीड्स",
    "Feed Detail": "फ़ीड विवरण",
    "Featured": "प्रदर्शित",
    "Pop. Posts": "जल्दी से आना। पदों",
    "Apply": "आवेदन करना",
    "Team Leaves": "टीम रवाना",
    "My Leaves": "मेरे पत्ते",
    "Hello": "नमस्ते",
    "Leave Ledger": "लेजर छोड़ो",
    "Org Leaves": "संगठन के पत्ते",
    "Employees": "कर्मचारी",
    "All Teams": "सभी टीमें",
    "My Team": "मेरी टीम",
    "Log Out": "लॉग आउट",
    "Awards": "पुरस्कार",
    "Quick Actions": "त्वरित कार्रवाई",
    "Ticket Management": "टिकट प्रबंधन",
    "Ticket Detail": "टिकट विवरण",
    "My Tickets": "मेरे टिकट",
    "Add Ticket": "टिकट जोड़ें",
    "Ticket Detail": "टिकट विवरण",
    "Leave": "छुट्टी",
    "Apply": "आवेदन करना",
    "My Leaves": "मेरे पत्ते",
    "Team Leaves": "टीम रवाना",
    "Org Leaves": "संगठन के पत्ते",
    "Leave Ledger": "लेजर छोड़ो",
    "My Leave Completed Leave": "मेरी छुट्टी पूरी हो गई",
    "Gallery": "गैलरी",
    "Single Gallery": "एकल गैलरी",
    "Add Media": "मीडिया जोड़ो",
    "Hr Assessment": "घंटे का आकलन",
    "My Assessment": "मेरा आकलन",
    "EmployeeAssessment": "कर्मचारी मूल्यांकन",
    "Hr Assessment": "घंटे का आकलन",
    "Recruitment": "भर्ती",
    "Recruitment Dashboard": "भर्ती डैशबोर्ड",
    "Recruitment Details": "भर्ती विवरण",
    "Create Position": "स्थिति बनाएँ",
    "Applicant Details": "आवेदक का विवरण",
    "Add Applicant": "आवेदक जोड़ें",
    "Applicant Search": "आवेदक खोजें",
    "Work From Home": "घर से काम",
    "Work From Home Dashboard": "होम डैशबोर्ड से कार्य करें",
    "My Work From Home": "घर से मेरा काम",
    "Team Work From Home": "घर से टीम वर्क",
    "Completed": "पुरा होना।",
    "Pending": "लंबित",
    "More": "अधिक",
    "Communication Panel": "संचार पैनल",
    "Create Reminders": "अनुस्मारक बनाएँ",
    "Reminders": "अनुस्मारक",
    "First time dashboard": "पहली बार डैशबोर्ड",
    "Audit Trails": "ऑडिट ट्रैल्स",
    "Create Owner Page": "स्वामी पृष्ठ बनाएँ",
    "Account Owner Page": "खाता स्वामी पृष्ठ",
    "Change Password": "पासवर्ड बदलें",
    "OTP Verification": "ओटीपी सत्यापन",
    "Policy": "नीति",
    "AddPolicy": "नीति जोड़ें",
    "Policies": "नीतियों",
    "Policydetail": "नीति विवरण",
    "All Teams": "सभी टीमें",
    "My Teams": "मेरी टीमें",
    "New": "नया",
    "Self Learning": "स्वयं सीखना",
    "Instructor Training": "प्रशिक्षक प्रशिक्षण",
    "Task Management": "कार्य प्रबंधन",
    "Task Detail": "कार्य विवरण",
    "Search": "खोज",
    "Search Result": "खोज का परिणाम",
    "What would you like to search": "आप क्या खोजना चाहेंगे",
    "Search Employee & their post": "कर्मचारी और उनके पद खोजें",
    "Profile": "प्रोफ़ाइल",
    "Change password": "पासवर्ड बदलें",
    "Send Us Feedback": "हमें फीडबैक भेजें",
    "2022 © OrgGenie - Your Organization Portal. Powered By": "2022 © ऑर्गेनी - आपका संगठन पोर्टल। द्वारा संचालित",
    "BizBrolly": "बिज़ब्रॉली",
    "Version 16.6": "संस्करण 16.6",
    "Log Out": "लॉग आउट",
    "Add App": "ऐप जोड़ें",
    "App Title": "ऐप शीर्षक",
    "Links": "लिंक",
    "Existing App": "मौजूदा ऐप",
    "Apps": "ऐप्स",
    "Decline": "गिरावट",
    "Save": "बचाना",

}
export default Hindi;